import { useEffect } from "react";

import {
  organizationRecurringOrderDataSelector,
  organizationRecurringOrderLoadingSelector
} from "Reducers/organization/order/order.selectors";
import { useAppDispatch, useAppSelector } from "Store/hooks";

import { getOrganizationRecurringOrderThunk } from "../thunks/getOrganizationRecurringOrder.thunk";

export const useLoadRecurringOrder = (
  organizationId: string,
  organizationDescriptionId: string
) => {
  const dispatch = useAppDispatch();

  const order = useAppSelector(organizationRecurringOrderDataSelector);
  const loading = useAppSelector(organizationRecurringOrderLoadingSelector);

  useEffect(() => {
    if (organizationId) {
      dispatch(
        getOrganizationRecurringOrderThunk({
          organizationId: organizationDescriptionId
        })
      );
    }
  }, [dispatch, organizationDescriptionId, organizationId]);

  return {
    order,
    loading
  };
};
